import Loadable from 'UIComponents/decorators/Loadable';
const AsyncListingAlert = Loadable({
  loader: () => import( /* webpackChunkName: "listing-alert" */'email-management-lib/AffectedEmails/components/ListingAlert'),
  LoadingComponent: () => null
});
export default AsyncListingAlert;